import React from 'react'
import { Card, Drawer, Form, Table, Icon, notification, Button, Tooltip, Input, Row, Col, Checkbox, Popover } from 'antd'
import _ from 'lodash'
import { connect } from 'react-redux'
import Request from '../../request'
import { TableComp, FormUtils as GetAllFormFields } from 'sz-react-utils'
import moment from 'moment';
import './styles.less';
import async, { auto } from 'async';
let dateFormat = localStorage.getItem('company-details') ? JSON.parse(localStorage.getItem('company-details')).dateFormat : 'DD.MM.YYYY';
const activeUser = localStorage.getItem('user') ? JSON.parse(localStorage.getItem('user')) : {};
@Form.create()

class CompanyBankDetails extends React.Component {
    state = {
        visible: true,
        invoiceType: '',
        companyBankId: '',
        invoiceNumber: '',
        invoiceGeneratedDate: '',
        taxTypeId: '',
        cpTaxTypeId: '',
        invoiceToId: '',
        showInvoiceNumber: false,
        showInvoiceDate: false,
        allInvoiceToDetails: [],
        companyDetails: [],
        allTaxes: [],
        taxTypeArray: [],
        countryArr: [],
        invoiceLinkWith: '',
        universities: [],
        channelPartners: [],
        selectMultipleRecords: [],
        enableBTN: false,
        selectedStudents: [],
        universityCommissions: [],
        invoiceThroughCp: false,
        taxPercentange: 0,
        hasConversionRate: false
    }
    handleInvoiceTSubmit = e => {
        const { form } = this.props
        e.preventDefault()
        form.validateFieldsAndScroll(async (err, valData) => {
            if (!err) {
                let values = _.clone(valData)
                let x = await Request.addInvoiceToDetails(values)

                if (!x.error) {
                    notification.success({
                        message: 'Invoice To Added successfully'
                    })
                    form.resetFields()
                    this.getAllInvoiceToDetails();
                    this.closeInvoiceTODetailsDrawar();
                } else {
                    notification.error({
                        message: 'Error Saving',
                        description: x.msg
                    })
                }
            }
        })
    }
    handleCompanySubmit = e => {
        const { form } = this.props
        e.preventDefault()
        form.validateFieldsAndScroll(async (err, valData) => {
            if (!err) {
                let values = _.clone(valData)
                let x = await Request.addCompanyDetails(values);
                if (!x.error) {
                    notification.success({
                        message: 'Bank Added successfully'
                    })
                    form.resetFields()
                    this.loadCompanyBankDetails();
                    this.closeCompanyDetailsDrawar();
                } else {
                    notification.error({
                        message: 'Error Saving',
                        description: x.msg
                    })
                }
            }
        })
    }
    handleTaxSubmit = e => {
        const { form } = this.props
        e.preventDefault()
        form.validateFieldsAndScroll(async (err, valData) => {
            if (!err) {
                let values = _.clone(valData)
                values.taxTypeArray = this.state.taxTypeArray;
                let x = await Request.addTaxDetails(values);
                if (!x.error) {
                    notification.success({
                        message: 'Tax Detail Added successfully'
                    })
                    form.resetFields()
                    this.getAllTaxes();
                    this.closeTaxDetailsDrawar();
                } else {
                    notification.error({
                        message: 'Error Saving',
                        description: x.msg
                    })
                }
            }
        })
    }
    loadCountry() {
        let params = {
            results: 100,
            sortField: "countryName",
            sortOrder: "ascend",
            businessId: activeUser && activeUser.businessId,
        };
        Request.getCountriesWithoutAuth(params)
            .then((resp) => {
                if (resp) {
                    let temp = [];
                    _.each(resp.data, (vv) => {
                        temp.push({
                            display: vv.countryName,
                            id: vv._id,
                        });
                    });
                    this.setState({ countryArr: temp });
                }
            })
            .catch((err) => {
            });
    }
    getAllInvoiceToDetails = async () => {
        let params = {};
        params.results = 10000;
        params.count = 10000;
        params.sortField = 'invoiceToName'
        params.sortOrder = 'ascend'
        let data = await Request.getInvoiceToDetails({
            ...params,
            regExFilters: []
        });
        this.setState({ allInvoiceToDetails: data.data });
    }
    getAllTaxes = async () => {
        let params = {};
        params.results = 10000;
        params.count = 10000;
        let data = await Request.getTaxDetails({
            ...params,
            regExFilters: []
        });
        this.setState({ allTaxes: data.data });
    }
    loadCompanyBankDetails = async () => {
        let response = await Request.getCompanyBankDetails();
        if (!response.error) {
            this.setState({ companyDetails: response.results });
        } else {
            notification.error({
                message: 'Error generating invoice'
            })
        }
    }
    loadUniversity = async () => {
        Request.loadSimpleUniversities({ sort: { instituteName: 1 } })
            .then(resp => {
                resp.arr = resp.arr.reduce((temp, vv) => {
                    temp.push({ _id: vv._id, display: vv.universityInstitutionName })
                    return temp
                }, [])

                this.setState({ 'universities': resp.arr });
            })
            .catch(err => {
                console.log(err)
            })
    }
    loadChannelPartner = async () => {
        Request.loadChannelPartners({
            results: 10000,
            count: 1000
        })
            .then(resp => {
                resp.data = resp.data.reduce((temp, vv) => {
                    temp.push({ _id: vv._id, display: vv.channelPartnerName })
                    return temp
                }, [])

                this.setState({ 'channelPartners': resp.data });
            })
            .catch(err => {
                console.log(err)
            })
    }

    loadInvoiceDetail = async () => {
        const { selectMultipleRecords } = this.state;
        var universityId = [];
        let studentIds = [];
        for (let key in selectMultipleRecords) {
            let obj = selectMultipleRecords[key];
            universityId.push(obj.universityId);
            studentIds.push(obj.studentId);
        }
        let uniResponse = await Request.getCommissionUniversities({ universityId });
        console.log(uniResponse);
        let selectMultipleRecordData = [];
        if (uniResponse.data && uniResponse.data.length) {
            uniResponse.data.map(async (comm, index) => {
                // if(comm && comm.bonusAny === "Yes" && comm.bonusDetails.length>0) {
                //     let findtotalInvoicesOfUniversities = await Request.getUniversityInvoiceCount({universityId:comm.universityId._id});
                //     console.log(comm.bonusDetails)
                //     console.log(findtotalInvoicesOfUniversities)
                //     // const findObject = comm.bonusDetails.filter(obj =>{
                //     //      return parseFloat(obj.maximumStudents) >= findtotalInvoicesOfUniversities.total
                //     // })
                //     // console.log(findObject)
                // }
                for (let key in selectMultipleRecords) {
                    let record = selectMultipleRecords[key];
                    if (record.universityId == comm.universityId._id) {
                        record.commissionFromUniversity = comm.status === "Pending" || comm.status === "Inactive" ? 0 : comm.commissionFromUniversity
                        record.commissionTypeFrom = comm.commissionTypeFrom
                    }
                    selectMultipleRecordData[key] = record;
                }
            })

        }
        console.log(selectMultipleRecordData);
        this.setState({ selectMultipleRecords: selectMultipleRecordData });
        let response = await Request.loadDashboardStudentList({
            arr: studentIds,
            results: 10000,
        });
        if (response.data) {
            let selectedStudents = [];
            for (let key in selectMultipleRecords) {
                let obj = selectMultipleRecords[key];
                _.each(response.data, (std) => {
                    if (std._id == obj.studentId) {
                        selectedStudents[key] = std
                    }
                })
            }
            this.setState({ selectedStudents: selectedStudents })
        }
    }

    async componentDidMount() {
        let selectMultipleRecords = this.props.selectMultipleRecords;
        this.setState({ selectMultipleRecords }, async () => {
            await this.loadInvoiceDetail();
        });
        this.loadCompanyBankDetails();
        this.getAllTaxes();
        this.getAllInvoiceToDetails();
        this.loadCountry();
        this.loadUniversity();
        this.loadChannelPartner();
    }
    onClose = () => {
        this.setState({
            visible: false
        })

        setTimeout(() => {
            this.props.onClose()
        }, 400)
    }

    selectCompanyDetais = (e) => {
        this.setState({ companyBankId: e.target.value });
    }

    doSubmitCompanyBankId = async (e, invoiceThroughCp) => {
        const { invoiceType, selectMultipleRecords, hasConversionRate, cpTaxTypeId, companyBankId, invoiceNumber, invoiceGeneratedDate, taxPaidBy, taxTypeId, invoiceToId, showInvoiceDate } = this.state;
        if (!invoiceGeneratedDate && showInvoiceDate) {
            return notification.error({
                message: 'Invoice Date Is Required!'
            })
        }
        if (!companyBankId) {
            return notification.error({
                message: 'Company Is Required!'
            })
        }
        if (taxPaidBy == 'University' && !taxTypeId) {
            return notification.error({
                message: 'Tax Is Required!'
            })
        }
        const { dispatch } = this.props
        let selectedInvoices = [];
        let invoiceGeneratedRecordIds = [];

        for (const key in selectMultipleRecords) {
            if (Object.hasOwnProperty.call(selectMultipleRecords, key)) {
                const selectMultipleRecord = selectMultipleRecords[key];
                selectedInvoices.push(selectMultipleRecord);
                invoiceGeneratedRecordIds.push(selectMultipleRecord.invoiceGeneratedRecordId);
            }
        }
        this.setState({ enableBTN: true })
        let response = await Request.financeGenerateInvoice({
            selectedInvoices: selectedInvoices,
            invoiceType,
            companyBankId,
            invoiceGeneratedDate,
            invoiceNumber,
            taxPaidBy,
            taxTypeId,
            invoiceToId,
            invoiceThroughCp,
            hasConversionRate,
            cpTaxTypeId,
        });
        this.setState({ enableBTN: false })
        if (!response.error) {
            this.props.onSelect(true);
            notification.success({ message: 'Invoice generated Successfully' });
            window.open(`/finance-desk?invId=${response.invoiceId}`, '_blank').focus();
        } else {
            notification.error({
                message: (response.msg ? response.msg : 'Error generating invoice')
            })
        }

    }

    closeCompanyDetailsDrawar = () => {
        this.setState({ showCompanyDetailsDrawar: false });
    }

    closeTaxDetailsDrawar = () => {
        this.setState({ showTaxDetailsDrawar: false });
    }


    updateCpTax = async (e) => {
        if (e === "") {
            this.setState({ cpTaxTypeId: e, taxPercentange: 0 })
        }
        let response = await Request.financeTaxDetailsByID({ id: e })
        let { taxTypeArray } = response.doc
        let totalTaxPercentage = 0
        _.each(taxTypeArray, (tax) => {
            totalTaxPercentage += parseFloat(tax.taxValue)
        })
        this.setState({ cpTaxTypeId: e, taxPercentange: totalTaxPercentage })

    }

    closeInvoiceTODetailsDrawar = () => {
        this.setState({ showInvoiceToDetailsDrawar: false });
    }

    render() {
        const {
            form: { getFieldDecorator }
        } = this.props
        const { enableBTN, selectedStudents, universityCommissions, selectMultipleRecords, hasConversionRate, companyDetails, universities, countryArr, id, taxTypeArray, channelPartners, allTaxes, taxPaidBy, allInvoiceToDetails, showInvoiceNumber, showInvoiceDate } = this.state;
        const inputTypesCompany = {
            fields: [
                {
                    label: 'Company Name',
                    key: 'companyName',
                    required: true
                },
                {
                    label: 'Company Type',
                    key: 'companyType',
                    required: true
                },
                {
                    label: 'Company Email',
                    key: 'companyEmail',
                    required: true,
                    type: 'email'
                },
                {
                    label: 'Bank Name',
                    key: 'bankName',
                    required: true
                },
                {
                    label: 'Bank Address',
                    key: 'bankAddress',
                    required: true
                },
                {
                    label: 'Account Number',
                    key: 'accountNumber',
                    required: true
                },
                {
                    label: 'Account Name',
                    key: 'accountName',
                    required: true
                },
                {
                    label: 'Bank Swift/BIC',
                    key: 'bankSwiftBicCode'
                },
                {
                    label: 'Bank Ifsc Code',
                    key: 'bankIfscCode'
                },
                {
                    label: 'Transit Number',
                    key: 'transitNumber'
                },
                {
                    label: 'Institution Number',
                    key: 'institutionNumber'
                },
                {
                    label: 'HST Registration Number',
                    key: 'HSTRegistrationNumber'
                },
                {
                    label: 'Status',
                    key: 'companyStatus',
                    type: 'select',
                    required: true,
                    showSearch: true,
                    disabled: false,
                    options: [
                        'Active', 'Inactive'
                    ],
                    onChange: v => {
                        this.props.form.setFieldsValue({
                            companyStatus: v
                        })
                    }
                }
            ]
        };
        const inputTypesTax = {
            fields: [
                {
                    label: 'Tax Title',
                    key: 'taxTitle'
                },
                {
                    label: 'Select Country ',
                    key: 'countryId',
                    required: true,
                    type: 'select',
                    showSearch: true,
                    disabled: false,
                    options: countryArr,
                    onChange: v => {
                        this.props.form.setFieldsValue({
                            countryId: v
                        })
                    }
                },
                {
                    label: 'Status',
                    key: 'taxStatus',
                    type: 'select',
                    required: true,
                    showSearch: true,
                    disabled: false,
                    options: [
                        'Active', 'Inactive'
                    ],
                    onChange: v => {
                        this.props.form.setFieldsValue({
                            taxStatus: v
                        })
                    }
                },
                {
                    label: 'Tax Type',
                    key: 'taxTypeKeyWord',
                    customProps: {
                        style: {
                            width: '75%'
                        }
                    },
                    rightComp: <Button style={{ marginLeft: '3px' }} type="primary" onClick={() => {
                        let taxType = this.props.form.getFieldValue('taxTypeKeyWord');
                        let taxTypeArray = this.state.taxTypeArray;
                        taxTypeArray.push({
                            taxName: taxType,
                            taxValue: 0
                        })
                        this.setState({ taxTypeArray });
                    }}>{<Icon type="plus" />}</Button>
                }
            ]
        };
        let content = <p>This invoice is created when your student is enrolled in an institute through a channel partner.<br />
            Enter all the details received by your channel partner to create the invoice.</p>

        const inputTypesInvoice = {
            fields: [
                {
                    label: 'Invoice To Name',
                    key: 'invoiceToName',
                    required: true
                },
                {
                    label: 'Invoice Address',
                    key: 'invoiceAddress',
                    required: true
                },
                {
                    label: 'Kind Attention',
                    key: 'kindAttention',
                    required: true
                },
                {
                    label: 'Invoice Email',
                    key: 'invoiceToEmail',
                    required: true,
                    type: 'email'
                },
                {
                    label: 'Invoice Phone',
                    key: 'invoiceToPhone',
                    required: true
                },
                {
                    label: 'Invoice Category',
                    key: 'invoiceToCategory',
                    required: true
                },
                {
                    label: 'Status',
                    key: 'invoiceToStatus',
                    type: 'select',
                    required: true,
                    showSearch: true,
                    disabled: false,
                    options: [
                        'Active', 'Inactive'
                    ],
                    onChange: v => {
                        this.props.form.setFieldsValue({
                            invoiceToStatus: v
                        })
                    }
                },
                {
                    label: 'Invoice Linked With',
                    key: 'invoiceLinkWith',
                    type: 'select',
                    required: true,
                    showSearch: true,
                    disabled: false,
                    options: [
                        'University', 'Channel Partner'
                    ],
                    onChange: v => {
                        this.setState({ invoiceLinkWith: v });
                        this.props.form.setFieldsValue({
                            invoiceLinkWith: v
                        })
                    }
                },
                {
                    label: 'University',
                    key: 'universityId',
                    type: 'select',
                    required: true,
                    showSearch: true,
                    disabled: false,
                    options: universities,
                    hidden: (this.state.invoiceLinkWith != 'University'),
                    onChange: v => {
                        this.setState({ universityId: v });
                        this.props.form.setFieldsValue({
                            universityId: v
                        })
                    }
                },
                {
                    label: 'Channel Partner',
                    key: 'channelPartnerId',
                    type: 'select',
                    required: true,
                    showSearch: true,
                    disabled: false,
                    options: channelPartners,
                    hidden: (this.state.invoiceLinkWith != 'Channel Partner'),
                    onChange: v => {
                        this.setState({ channelPartnerId: v });
                        this.props.form.setFieldsValue({
                            channelPartnerId: v
                        })
                    }
                }
            ]
        };

        let taxColumns = [
            {
                title: 'Tax Name',
                key: 'taxName',
                render: (text, record) => {
                    return (
                        <div>{record.taxName}</div>
                    )
                }
            },
            {
                title: 'Value',
                key: 'taxValue',
                dataIndex: 'taxValue',
                render: (item, record, index) => {
                    return (<div>
                        <Input type='tax' onChange={(e) => {
                            taxTypeArray[index].taxValue = e.target.value;
                            this.setState({ taxTypeArray });
                        }} value={record.taxValue} />
                    </div>)
                }
            }
        ]
        let $this = this;
        let totalAmount = selectedStudents && selectedStudents.reduce(function (oldValue, selectedStudent, index) {
            return (selectMultipleRecords[selectedStudent._id + '-' + index] ? (selectMultipleRecords[selectedStudent._id + '-' + index].commissionTypeFrom != undefined && selectMultipleRecords[selectedStudent._id + '-' + index].commissionTypeFrom == 'Percentage' ? (parseFloat(selectMultipleRecords[selectedStudent._id + '-' + index].commissionFromUniversity) * parseFloat(selectMultipleRecords[selectedStudent._id + '-' + index].tutionFee) / 100) : (selectMultipleRecords[selectedStudent._id + '-' + index].commissionFromUniversity != undefined ? selectMultipleRecords[selectedStudent._id + '-' + index].commissionFromUniversity : 0)) : 0) + oldValue;
        }, 0);
        let selectedInvoicesHtml = [];
        let channelPartnersLength = 0
        let totalInvoiceLength = 0
        let totalLength = 0
        let invoiceThroughCp = this.state.invoiceThroughCp;

        for (let itemKey in selectedStudents) {
            totalInvoiceLength++
            if (selectMultipleRecords && selectMultipleRecords[itemKey] && selectMultipleRecords[itemKey].universityPartnership === "Channel Partner") {
                channelPartnersLength++
            }
        }
        if (channelPartnersLength === totalInvoiceLength) {
            invoiceThroughCp = true;
        }
        for (let key in selectedStudents) {
            let selectedStudent = selectedStudents[key];
            let selectMultipleRecord = selectMultipleRecords[key];
            totalLength++;
            // if(selectMultipleRecords[key].universityPartnership === "Channel Partner") {
            //     channelPartnersLength++
            // }
            let commissionFromUniversity = (selectMultipleRecords[key] && selectMultipleRecords[key].commissionFromUniversity != undefined ? selectMultipleRecords[key].commissionFromUniversity : 0);
            let tutionFee = (selectMultipleRecords[key] && selectMultipleRecords[key].tutionFee != undefined ? selectMultipleRecords[key].tutionFee : 0);
            selectedInvoicesHtml.push(
                <tr key={key}>
                    <td className='ant-table-row-cell-break-word'>{selectedStudent.visaDesk && selectedStudent.visaDesk.selectedCourse && selectedStudent.visaDesk.selectedCourse.instituteStudentId ? selectedStudent.visaDesk.selectedCourse.instituteStudentId : selectedStudent.instituteStudentId ? selectedStudent.instituteStudentId : ''}</td>
                    <td className='ant-table-row-cell-break-word'>{selectedStudent.studentName}</td>
                    <td className='ant-table-row-cell-break-word'>{selectedStudent.dateOfBirth ? moment(selectedStudent.dateOfBirth).format(dateFormat) : ''}</td>
                    <td className='ant-table-row-cell-break-word'>{selectedStudent.visaDesk ? selectedStudent.visaDesk.selectedCourse.courseName : ''}{selectedStudent.visaDesk ? selectedStudent.visaDesk.selectedCourse.campusName ? `(${selectedStudent.visaDesk.selectedCourse.campusName})` : '' : ''}</td>
                    <td className='ant-table-row-cell-break-word'>{selectedStudent.visaDesk ? moment(selectedStudent.visaDesk.courseStartDate).format(dateFormat) : ''}</td>
                    <td className='ant-table-row-cell-break-word'>{selectMultipleRecords[key] && selectMultipleRecords[key].universityName ? selectMultipleRecords[key].universityName : null}</td>
                    <td className='ant-table-row-cell-break-word'>
                        {selectMultipleRecords &&
                            selectMultipleRecords[key] &&
                            selectMultipleRecords[key].universityAgreement ? (
                            <Button
                                type='primary'
                                href={selectMultipleRecords[key].universityAgreement}
                                target='_blank'
                                icon='eye'
                            />
                        ) : (
                            "Missing"
                        )}
                    </td>

                    <td className='ant-table-row-cell-break-word'>
                        {
                            selectedStudent.nextInvoiceGenerationDates.map((date, index) => {
                                let ifChecked = selectMultipleRecords[key] && selectMultipleRecords[key].invoiceGeneratedRecordId == date._id ? true : false;
                                if (ifChecked) {
                                    return (<div key={index}>{moment(date.generationDate).format(dateFormat)}</div>);
                                }
                            })
                        }
                    </td>
                    <td className='ant-table-row-cell-break-word'>
                        <Input
                            type='text'
                            value={(selectMultipleRecord ? selectMultipleRecord.tutionFee : 0)}
                            onChange={(e) => {
                                selectMultipleRecords[key].tutionFee = e.target.value;
                                $this.setState({ selectMultipleRecords });
                            }}
                        />
                    </td>
                    <td className='ant-table-row-cell-break-word'>{selectMultipleRecord ? selectMultipleRecord.commissionFromUniversity : 0}</td>
                    {/* <td className='ant-table-row-cell-break-word'>
                        <Input
                            type='text'
                            value={(selectMultipleRecord ? selectMultipleRecord.commissionFromUniversity : 0)}
                            onChange={(e) => {
                                selectMultipleRecords[key].commissionFromUniversity = e.target.value;
                                $this.setState({ selectMultipleRecords });
                            }}
                        />
                    </td> */}
                    {/* <td className='ant-table-row-cell-break-word'>{selectMultipleRecords[key] && selectMultipleRecords[key].commissionTypeFrom == 'Percentage'?(commissionFromUniversity && tutionFee?(parseFloat(commissionFromUniversity) * parseFloat(tutionFee)/100).toFixed(2):0):parseFloat(commissionFromUniversity).toFixed(2)}</td> */}
                    {console.log(key)}
                    {console.log(selectMultipleRecords)}
                    <td className='ant-table-row-cell-break-word'>{selectMultipleRecords[key] && selectMultipleRecords[key].commissionTypeFrom == 'Percentage' ? (commissionFromUniversity && tutionFee ? (parseFloat(commissionFromUniversity) * parseFloat(tutionFee) / 100).toFixed(2) : 0) : parseFloat(commissionFromUniversity).toFixed(2)} {selectMultipleRecords && selectMultipleRecords[key] && selectMultipleRecords[key].currency}</td>
                    <td className='ant-table-row-cell-break-word' hidden={invoiceThroughCp ? false : true}>
                        <Input
                            type='text'
                            value={(selectMultipleRecord ? selectMultipleRecord.receivedCommision : 0)}
                            onChange={(e) => {
                                selectMultipleRecords[key].receivedCommision = e.target.value;
                                $this.setState({ selectMultipleRecords });
                            }}
                        />
                    </td>
                    {/* parseFloat(commissionFromUniversity).toFixed(2) */}
                    <td className='ant-table-row-cell-break-word' hidden={invoiceThroughCp ? false : true}>{selectMultipleRecords[key] && selectMultipleRecords[key].commissionTypeFrom == 'Percentage' ? selectMultipleRecords[key].receivedCommision ? ((parseFloat(commissionFromUniversity) * parseFloat(tutionFee) / 100) * parseFloat(selectMultipleRecords[key].receivedCommision) / 100).toFixed(2) : 0 : selectMultipleRecords[key] && selectMultipleRecords[key].receivedCommision ? ((parseFloat(commissionFromUniversity) * selectMultipleRecords[key].receivedCommision) / 100).toFixed(2) : parseFloat(commissionFromUniversity).toFixed(2)}</td>
                    <td className='ant-table-row-cell-break-word' hidden={invoiceThroughCp && hasConversionRate ? false : true}>
                        <Input
                            type='text'
                            value={(selectMultipleRecord ? selectMultipleRecord.conversionRate : 0)}
                            onChange={(e) => {
                                selectMultipleRecords[key].conversionRate = e.target.value;
                                $this.setState({ selectMultipleRecords });
                            }}
                        />
                    </td>
                    <td className='ant-table-row-cell-break-word' hidden={invoiceThroughCp && hasConversionRate ? false : true}>{selectMultipleRecords[key] && selectMultipleRecords[key].commissionTypeFrom == 'Percentage' ?
                        selectMultipleRecords[key] && selectMultipleRecords[key].receivedCommision && selectMultipleRecords[key].conversionRate ?
                            ((((parseFloat(selectMultipleRecords[key].commissionFromUniversity) * parseFloat(selectMultipleRecords[key].tutionFee) / 100) * parseFloat(selectMultipleRecords[key].receivedCommision) / 100)) * parseFloat(selectMultipleRecords[key].conversionRate) - (this.state.taxPercentange && this.state.taxPercentange > 0 ? ((((parseFloat(selectMultipleRecords[key].commissionFromUniversity) * parseFloat(selectMultipleRecords[key].tutionFee) / 100) * parseFloat(selectMultipleRecords[key].receivedCommision) / 100)) * parseFloat(selectMultipleRecords[key].conversionRate) * this.state.taxPercentange / (this.state.taxPercentange + 100)) : 0)).toFixed(2)
                            : 0
                        : selectMultipleRecords[key] && selectMultipleRecords[key].receivedCommision && selectMultipleRecords[key].conversionRate ? (((parseFloat(commissionFromUniversity) * selectMultipleRecords[key].receivedCommision) / 100) * selectMultipleRecords[key].conversionRate) - (this.state.taxPercentange && this.state.taxPercentange > 0 ?
                            ((((parseFloat(commissionFromUniversity) * selectMultipleRecords[key].receivedCommision) / 100) * selectMultipleRecords[key].conversionRate) * this.state.taxPercentange / (this.state.taxPercentange + 100))
                            : 0).toFixed(2) : 0}</td>
                    {/* {
                        console.log(this.state.taxPercentange && this.state.taxPercentange>0?
                            ((((parseFloat(commissionFromUniversity) * selectMultipleRecords[key].receivedCommision)/100) * selectMultipleRecords[key].conversionRate) * this.state.taxPercentange/(this.state.taxPercentange+100))
                            :0)
                    } */}
                    {/* <td className='ant-table-row-cell-break-word' hidden={invoiceThroughCp ? false : true}>{selectMultipleRecords[key] && selectMultipleRecords[key].commissionTypeFrom == 'Percentage' ? selectMultipleRecords[key] && selectMultipleRecords[key].receivedCommision && selectMultipleRecords[key].conversionRate ? ((((parseFloat(selectMultipleRecords[key].commissionFromUniversity) * parseFloat(selectMultipleRecords[key].tutionFee) / 100) * parseFloat(selectMultipleRecords[key].receivedCommision) / 100)) * parseFloat(selectMultipleRecords[key].conversionRate)).toFixed(2) : 0 : 0}</td> */}
                    <td className='ant-table-row-cell-break-word' hidden={invoiceThroughCp && hasConversionRate ? false : true}>{selectMultipleRecords[key] && selectMultipleRecords[key].commissionTypeFrom == 'Percentage' ? selectMultipleRecords[key] && selectMultipleRecords[key].receivedCommision && selectMultipleRecords[key].conversionRate && this.state.taxPercentange ? ((((((parseFloat(selectMultipleRecords[key].commissionFromUniversity) * parseFloat(selectMultipleRecords[key].tutionFee) / 100) * parseFloat(selectMultipleRecords[key].receivedCommision) / 100)) * parseFloat(selectMultipleRecords[key].conversionRate)) * this.state.taxPercentange / (this.state.taxPercentange + 100))).toFixed(2) : 0 :
                        this.state.taxPercentange && this.state.taxPercentange > 0 ?
                            ((((parseFloat(commissionFromUniversity) * selectMultipleRecords[key].receivedCommision) / 100) * selectMultipleRecords[key].conversionRate) * this.state.taxPercentange / (this.state.taxPercentange + 100)).toFixed(2)
                            : 0}</td>
                    <td className='ant-table-row-cell-break-word' hidden={invoiceThroughCp && hasConversionRate ? false : true}>
                        <Input type='text'
                            onChange={(e) => {
                                selectMultipleRecords[key].adjustmentAmount = e.target.value;
                                $this.setState({ selectMultipleRecords });
                            }} /></td>
                    {/* <td className='ant-table-row-cell-break-word' hidden={invoiceThroughCp ? false : true}>{selectMultipleRecords[key] && selectMultipleRecords[key].commissionTypeFrom == 'Percentage' ? selectMultipleRecords[key] && selectMultipleRecords[key].receivedCommision && selectMultipleRecords[key].conversionRate ? (((((parseFloat(selectMultipleRecords[key].commissionFromUniversity) * parseFloat(selectMultipleRecords[key].tutionFee) / 100) * parseFloat(selectMultipleRecords[key].receivedCommision) / 100)) * parseFloat(selectMultipleRecords[key].conversionRate)) + (this.state.taxPercentange?((((((parseFloat(selectMultipleRecords[key].commissionFromUniversity) * parseFloat(selectMultipleRecords[key].tutionFee) / 100) * parseFloat(selectMultipleRecords[key].receivedCommision) / 100)) * parseFloat(selectMultipleRecords[key].conversionRate)) * parseFloat(this.state.taxPercentange) / 100)):0) + (selectMultipleRecords[key] && selectMultipleRecords[key].adjustmentAmount? parseFloat(selectMultipleRecords[key].adjustmentAmount):0)).toFixed(2)   : 0 : 0}</td> */}
                    <td className='ant-table-row-cell-break-word' hidden={invoiceThroughCp && hasConversionRate ? false : true}>{selectMultipleRecords[key] && selectMultipleRecords[key].commissionTypeFrom == 'Percentage' ?
                        selectMultipleRecords[key] && selectMultipleRecords[key].receivedCommision && selectMultipleRecords[key].conversionRate ?
                            ((((parseFloat(selectMultipleRecords[key].commissionFromUniversity) * parseFloat(selectMultipleRecords[key].tutionFee) / 100) * parseFloat(selectMultipleRecords[key].receivedCommision) / 100)) * parseFloat(selectMultipleRecords[key].conversionRate) - (this.state.taxPercentange && this.state.taxPercentange > 0 ? ((((parseFloat(selectMultipleRecords[key].commissionFromUniversity) * parseFloat(selectMultipleRecords[key].tutionFee) / 100) * parseFloat(selectMultipleRecords[key].receivedCommision) / 100)) * parseFloat(selectMultipleRecords[key].conversionRate) * this.state.taxPercentange / (this.state.taxPercentange + 100)) : 0) +
                                ((((((parseFloat(selectMultipleRecords[key].commissionFromUniversity) * parseFloat(selectMultipleRecords[key].tutionFee) / 100) * parseFloat(selectMultipleRecords[key].receivedCommision) / 100)) * parseFloat(selectMultipleRecords[key].conversionRate)) * this.state.taxPercentange / (this.state.taxPercentange + 100))) + (selectMultipleRecords[key] && selectMultipleRecords[key].adjustmentAmount ? parseFloat(selectMultipleRecords[key].adjustmentAmount) : 0)
                            ).toFixed(2)
                            : 0
                        : selectMultipleRecords[key] && selectMultipleRecords[key].receivedCommision && selectMultipleRecords[key].conversionRate ?
                            (((((parseFloat(commissionFromUniversity) * selectMultipleRecords[key].receivedCommision) / 100) * selectMultipleRecords[key].conversionRate) - (this.state.taxPercentange && this.state.taxPercentange > 0 ?
                                ((((parseFloat(commissionFromUniversity) * selectMultipleRecords[key].receivedCommision) / 100) * selectMultipleRecords[key].conversionRate) * this.state.taxPercentange / (this.state.taxPercentange + 100))
                                : 0)) + (this.state.taxPercentange && this.state.taxPercentange > 0 ?
                                    ((((parseFloat(commissionFromUniversity) * selectMultipleRecords[key].receivedCommision) / 100) * selectMultipleRecords[key].conversionRate) * this.state.taxPercentange / (this.state.taxPercentange + 100))
                                    : 0) + (selectMultipleRecords[key].adjustmentAmount ? parseFloat(selectMultipleRecords[key].adjustmentAmount) : 0))
                            : 0}</td>
                    {/* {
                        console.log(selectMultipleRecords[key] && selectMultipleRecords[key].receivedCommision && selectMultipleRecords[key].conversionRate?
                            (((((parseFloat(commissionFromUniversity) * selectMultipleRecords[key].receivedCommision)/100) * selectMultipleRecords[key].conversionRate) - (this.state.taxPercentange && this.state.taxPercentange>0?
                                ((((parseFloat(commissionFromUniversity) * selectMultipleRecords[key].receivedCommision)/100) * selectMultipleRecords[key].conversionRate) * this.state.taxPercentange/(this.state.taxPercentange+100))
                                :0)) + (this.state.taxPercentange && this.state.taxPercentange>0?
                                ((((parseFloat(commissionFromUniversity) * selectMultipleRecords[key].receivedCommision)/100) * selectMultipleRecords[key].conversionRate) * this.state.taxPercentange/(this.state.taxPercentange+100))
                                :0) + (selectMultipleRecords[key].adjustmentAmount?parseFloat(selectMultipleRecords[key].adjustmentAmount):0))
                            :0)
                    } */}
                </tr>
            )
        }
        // if(channelPartnersLength === totalLength) {
        //     invoiceThroughCp = true;
        // }
        return (
            <Drawer
                title={
                    <div>
                        {`Invoice Details ${totalLength}`}
                        <a onClick={this.onClose} style={{ float: 'right', color: 'black' }}>
                            <Icon type={'close'} />
                        </a>
                    </div>
                }
                placement="right"
                closable={false}
                onClose={this.onClose}
                width={invoiceThroughCp ? 1250 : 1000}
                visible={this.state.visible}>
                <Card>
                    <Row>
                        {/* <Col span={12}>
                            <Checkbox
                                checked={invoiceThroughCp}
                                onChange={(y) => {
                                    this.setState({ invoiceThroughCp: y.target.checked })
                                }}
                            >Invoice Through Channel Partner <Popover placement='bottomLeft' content={content}>?</Popover>
                            </Checkbox>
                        </Col> */}
                        <Col span={12}>
                            {invoiceThroughCp ?
                                <Row>
                                    <Col span={8}>
                                        <select name='taxTypeId' style={{ 'maxWidth': '300px', 'marginBottom': '10px' }} className='form-control' onChange={(e) => this.updateCpTax(e.target.value)}>
                                            <option value="">Choose Tax</option>
                                            {
                                                allTaxes && allTaxes.length ?
                                                    allTaxes.map((item, index) => {
                                                        return (<option value={item._id} key={index}>{item.taxTitle}</option>)
                                                    })
                                                    : null
                                            }
                                        </select>
                                    </Col>
                                </Row>
                                : null}
                        </Col>
                        <Col span={12}>
                            {invoiceThroughCp ?
                                <Checkbox
                                    checked={hasConversionRate}
                                    onChange={(y) => {
                                        this.setState({ hasConversionRate: y.target.checked })
                                    }}
                                >Have Conversion Rate <Popover placement='bottomLeft' content={content}>?</Popover>
                                </Checkbox>
                                : null}

                        </Col>
                    </Row>
                    <div className='ant-table ant-table-small ant-table-bordered ant-table-scroll-position-left ant-table-layout-fixed'>
                        <div className='ant-table-content'>

                            <div className='ant-table-scroll scrolling-table' style={{ overflow: 'auto' }}>
                                <table className='ant-table-fixed' >
                                    <thead className='ant-table-thead'>
                                        <tr>
                                            <th className='ant-table-row-cell-break-word' >Student ID</th>
                                            <th className='ant-table-row-cell-break-word' >Student Name</th>
                                            <th className='ant-table-row-cell-break-word' >Date Of Birth</th>
                                            <th className='ant-table-row-cell-break-word' >Course</th>
                                            <th className='ant-table-row-cell-break-word' >Course Start Date</th>
                                            <th className='ant-table-row-cell-break-word' style={{ width: auto }} >University Name</th>
                                            <th className='ant-table-row-cell-break-word' style={{ width: auto }} >University Agreement</th>
                                            <th className='ant-table-row-cell-break-word' >Invoice Date</th>
                                            <th className='ant-table-row-cell-break-word' >Tuition Fee Paid</th>
                                            <th className='ant-table-row-cell-break-word' >Commission Percentage</th>
                                            <th className='ant-table-row-cell-break-word' >Commission Amount</th>
                                            <th className='ant-table-row-cell-break-word' hidden={invoiceThroughCp ? false : true}>% Received Comm.</th>
                                            <th className='ant-table-row-cell-break-word' hidden={invoiceThroughCp ? false : true}>Commission Received By CP</th>
                                            <th className='ant-table-row-cell-break-word' hidden={invoiceThroughCp && hasConversionRate ? false : true}>Conversion Rate</th>
                                            <th className='ant-table-row-cell-break-word' hidden={invoiceThroughCp && hasConversionRate ? false : true}>Net Received</th>
                                            <th className='ant-table-row-cell-break-word' hidden={invoiceThroughCp && hasConversionRate ? false : true}>Tax Amount</th>
                                            <th className='ant-table-row-cell-break-word' hidden={invoiceThroughCp && hasConversionRate ? false : true}>Adjustment</th>
                                            <th className='ant-table-row-cell-break-word' hidden={invoiceThroughCp && hasConversionRate ? false : true}>Gross Amount</th>

                                        </tr>
                                    </thead>
                                    <tbody className='ant-table-tbody '>
                                        {
                                            selectedInvoicesHtml
                                        }
                                    </tbody>
                                    <tfoot className='ant-table-tfoot'>
                                        <tr>
                                            <th className='ant-table-row-cell-break-word'>Total:- </th>
                                            <th className='ant-table-row-cell-break-word'></th>
                                            <th className='ant-table-row-cell-break-word'></th>
                                            <th className='ant-table-row-cell-break-word'></th>
                                            <th className='ant-table-row-cell-break-word'></th>
                                            <th className='ant-table-row-cell-break-word'></th>
                                            <th className='ant-table-row-cell-break-word'></th>
                                            <th className='ant-table-row-cell-break-word'></th>
                                            <th className='ant-table-row-cell-break-word' hidden={invoiceThroughCp ? false : true}></th>
                                            <th className='ant-table-row-cell-break-word' hidden={invoiceThroughCp ? false : true}></th>
                                            <th className='ant-table-row-cell-break-word' hidden={invoiceThroughCp && hasConversionRate ? false : true}></th>
                                            <th className='ant-table-row-cell-break-word' hidden={invoiceThroughCp && hasConversionRate ? false : true}></th>
                                            <th className='ant-table-row-cell-break-word' hidden={invoiceThroughCp && hasConversionRate ? false : true}></th>
                                            <th className='ant-table-row-cell-break-word' hidden={invoiceThroughCp && hasConversionRate ? false : true}></th>
                                            <th className='ant-table-row-cell-break-word' hidden={invoiceThroughCp && hasConversionRate ? false : true}></th>
                                            <th className='ant-table-row-cell-break-word'></th>
                                            <th className='ant-table-row-cell-break-word'>{totalAmount ? totalAmount.toFixed(2) : ''}</th>
                                        </tr>
                                    </tfoot>
                                </table>
                            </div>
                        </div>
                    </div>
                </Card>
                <Card>
                    <Row>
                        <Col span={24}>
                            <select
                                name='invoiceType'
                                style={{ 'maxWidth': '300px', 'marginBottom': '10px' }}
                                className='form-control'
                                onChange={(e) => { this.setState({ invoiceType: e.target.value }) }}
                            >
                                <option value="">Choose Invoice Type</option>
                                <option value="Performa">Performa Invoice</option>
                                {/* <option value="Invoice">Invoice</option> */}
                            </select>
                        </Col>
                        <Col span={24}>
                            <label><b>Invoice Number</b></label>
                            <Row style={{ 'marginBottom': '10px', 'marginTop': '10px', 'marginLeft': '5px' }}>
                                <Col span={3}>
                                    <Button className={!showInvoiceNumber ? 'btn-invoice-active' : ''} onClick={() => { this.setState({ showInvoiceNumber: false }) }}>Auto Generate</Button>
                                </Col>
                                <Col span={2}>
                                    <Button className={showInvoiceNumber ? 'btn-invoice-active' : ''} onClick={() => { this.setState({ showInvoiceNumber: true }) }}>Manually Generate</Button>
                                </Col>
                            </Row>
                            {
                                showInvoiceNumber ?
                                    <Input
                                        type={'text'}
                                        name="invoiceNumber"
                                        style={{ 'maxWidth': '300px', 'marginBottom': '10px' }}
                                        placeholder="Invoice Number"
                                        onChange={(e) => { this.setState({ invoiceNumber: e.target.value }) }}
                                    />
                                    : null
                            }

                        </Col>
                        <Col span={24}>
                            <label><b>Invoice Date</b></label>
                            <Row style={{ 'marginBottom': '10px', 'marginTop': '10px', 'marginLeft': '5px' }}>
                                <Col span={3}>
                                    <Button className={!showInvoiceDate ? 'btn-invoice-active' : ''} onClick={() => { this.setState({ showInvoiceDate: false }) }}>Auto Select</Button>
                                </Col>
                                <Col span={2}>
                                    <Button className={showInvoiceDate ? 'btn-invoice-active' : ''} onClick={() => { this.setState({ showInvoiceDate: true }) }}>Manually Select</Button>
                                </Col>
                            </Row>
                            {
                                showInvoiceDate ?
                                    <Input
                                        type={'date'}
                                        style={{ 'maxWidth': '300px', 'marginBottom': '10px' }}
                                        name="invoiceGeneratedDate"
                                        placeholder="Invoice Date"
                                        onChange={(e) => { this.setState({ invoiceGeneratedDate: e.target.value }) }}
                                    />
                                    : null
                            }
                        </Col>

                        <Col span={24}>
                            <Row>
                                <Col span={8}>
                                    <select name='companyBankId' style={{ 'maxWidth': '300px', 'marginBottom': '10px' }} className='form-control' onChange={(e) => { this.selectCompanyDetais(e) }}>
                                        <option value="">Choose Bank Details</option>
                                        {
                                            companyDetails && companyDetails.length ?
                                                companyDetails.map((item, index) => {
                                                    return (<option value={item._id} key={index}>{item.companyName}</option>)
                                                })
                                                : null
                                        }
                                    </select>
                                </Col>
                                <Col span={4}>
                                    <Button className='ant-btn-primary' onClick={(e) => { this.setState({ showCompanyDetailsDrawar: true }) }} type='button'>+</Button>
                                </Col>
                            </Row>
                        </Col>
                        <Col span={24}>
                            <select name='taxPaidBy' style={{ 'maxWidth': '300px', 'marginBottom': '10px' }} className='form-control' onChange={(e) => { this.setState({ taxPaidBy: e.target.value }) }}>
                                <option value="">Choose Tax Paid By</option>
                                <option value="Company">Company</option>
                                <option value="University">University</option>
                            </select>
                        </Col>
                        {
                            taxPaidBy ?
                                <Col span={24}>
                                    <Row>
                                        <Col span={8}>
                                            <select name='taxTypeId' style={{ 'maxWidth': '300px', 'marginBottom': '10px' }} className='form-control' onChange={(e) => { this.setState({ taxTypeId: e.target.value }) }}>
                                                <option value="">Choose Tax</option>
                                                {
                                                    allTaxes && allTaxes.length ?
                                                        allTaxes.map((item, index) => {
                                                            return (<option value={item._id} key={index}>{item.taxTitle}</option>)
                                                        })
                                                        : null
                                                }
                                            </select>
                                        </Col>
                                        <Col span={4}>
                                            <Button className='ant-btn-primary' onClick={(e) => { this.setState({ showTaxDetailsDrawar: true }) }} type='button'>+</Button>
                                        </Col>
                                    </Row>
                                </Col>
                                : null
                        }
                        <Col span={24}>
                            <Row>
                                <Col span={8}>
                                    <select name='invoiceToId' style={{ 'maxWidth': '300px', 'marginBottom': '10px' }} className='form-control' onChange={(e) => { this.setState({ invoiceToId: e.target.value }) }}>
                                        <option value="">Choose Invoice To</option>
                                        {
                                            allInvoiceToDetails && allInvoiceToDetails.length ?
                                                allInvoiceToDetails.map((item, index) => {
                                                    return (<option value={item._id} key={index}>{item.invoiceToName}</option>)
                                                })
                                                : null
                                        }
                                    </select>
                                </Col>
                                <Col span={4}>
                                    <Button className='ant-btn-primary' onClick={(e) => { this.setState({ showInvoiceToDetailsDrawar: true }) }} type='button'>+</Button>
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                    <Button
                        type="primary"
                        loading={enableBTN}
                        disabled={enableBTN}
                        onClick={(e) => this.doSubmitCompanyBankId(e, invoiceThroughCp)}> Generate
                    </Button>
                </Card>
                <Drawer
                    title={
                        <div>
                            New Bank Detail
                        </div>
                    }
                    width={500}
                    closable={false}
                    onClose={this.closeCompanyDetailsDrawar}
                    visible={this.state.showCompanyDetailsDrawar}>
                    <div>
                        <Form onSubmit={this.handleCompanySubmit} style={{ marginTop: 8 }}>
                            <div>
                                <GetAllFormFields
                                    inputSchema={inputTypesCompany}
                                    getFieldDecorator={getFieldDecorator}
                                />
                            </div>
                            <Row>
                                <Col span={8} />
                                <Col span={8}>
                                    <Button
                                        type="primary"
                                        htmlType="submit"
                                        style={{ marginBottom: 10 }}
                                        loading={this.props.loading}>
                                        SAVE
                                    </Button>
                                </Col>
                                <Col span={8} />
                            </Row>
                        </Form>
                    </div>
                </Drawer>
                <Drawer
                    title={
                        <div>
                            New Tax Detail
                        </div>
                    }
                    width={500}
                    closable={false}
                    onClose={this.closeTaxDetailsDrawar}
                    visible={this.state.showTaxDetailsDrawar}>
                    <div>
                        <Form onSubmit={this.handleTaxSubmit} style={{ marginTop: 8 }}>
                            <div>
                                <GetAllFormFields
                                    inputSchema={inputTypesTax}
                                    getFieldDecorator={getFieldDecorator}
                                />
                                {
                                    taxTypeArray && taxTypeArray.length > 0 &&
                                    <Col span={18} offset={6}>
                                        <Table
                                            rowKey={(item, x) => {
                                                return x
                                            }}
                                            dataSource={taxTypeArray || []}
                                            columns={taxColumns}
                                            pagination={false}
                                            border={true}
                                        />
                                    </Col>
                                }
                            </div>
                            <Row style={{ 'clear': 'both' }}>
                                <Col span={8} />
                                <Col span={8}>
                                    <Button
                                        type="primary"
                                        htmlType="submit"
                                        style={{ marginBottom: 10 }}
                                        loading={this.props.loading}>
                                        SAVE
                                    </Button>
                                </Col>
                                <Col span={8} />
                            </Row>
                        </Form>
                    </div>
                </Drawer>
                <Drawer
                    title={
                        <div>
                            New Invoice To Detail
                        </div>
                    }
                    width={500}
                    closable={false}
                    onClose={this.closeInvoiceTODetailsDrawar}
                    visible={this.state.showInvoiceToDetailsDrawar}>
                    <div>
                        <Form onSubmit={this.handleInvoiceTSubmit} style={{ marginTop: 8 }}>
                            <div>
                                <GetAllFormFields
                                    inputSchema={inputTypesInvoice}
                                    getFieldDecorator={getFieldDecorator}
                                />
                            </div>
                            <Row>
                                <Col span={8} />
                                <Col span={8}>
                                    <Button
                                        type="primary"
                                        htmlType="submit"
                                        style={{ marginBottom: 10 }}
                                        loading={this.props.loading}>
                                        SAVE
                                    </Button>
                                </Col>
                                <Col span={8} />
                            </Row>
                        </Form>
                    </div>
                </Drawer>
            </Drawer>
        )
    }
}

const mapStateToProps = ({ global, router }) => ({
    loading: global.buttonLoading,
    search: router.location.search
})
const mapDispatchToProps = dispatch => {
    return {
        dispatch
    }
}
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(CompanyBankDetails)